(function () {
  const COOKIE_NAME = 'age18_confirmed';
  let lastSubmitter = null;

  function setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    const cookieString = `; ${document.cookie}`;
    const parts = cookieString.split(`; ${encodeURIComponent(name)}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  // Fallback til e.submitter: gem sidste submit-knap der blev klikket
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('button[type="submit"], input[type="submit"]');
    if (btn) lastSubmitter = btn;
  }, true);

  function requiresAgeCheck(e) {
    const form = e.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return false;

    // 1) submitter (eller fallback)
    const submitter = e.submitter || lastSubmitter;
    if (submitter?.dataset?.ageCheck === '18') return true;

    // 2) form
    if (form.dataset?.ageCheck === '18') return true;

    // 3) wrapper
    const productWrap = form.closest?.('.js-product');
    if (productWrap?.dataset?.ageCheck === '18') return true;

    return false;
  }

  document.addEventListener('submit', (e) => {
    if (!requiresAgeCheck(e)) return;

    if (getCookie(COOKIE_NAME) === 'true') return;

    const ok = window.confirm(
        'Dette produkt er et håndkøbslægemiddel og må kun købes af personer, der er fyldt 18 år.\n\nTryk OK for at bekræfte, at du er fyldt 18 år.\nTryk Annuller for at afbryde.'
    );

    if (!ok) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    setCookie(COOKIE_NAME, 'true', 30);
  }, true);
})();
